export const initializeAIConfigurations = (configs = {}) => {
  const {
    enableTextToImageOpenAi = false,
    enableTextTospeechOpenAi = false,
    enableTextTospeechMicrosoft = false,
    aiVoiceServiceType = -1,
    aiVoiceName = "",
  } = configs;

  window.enable_speech_openai = enableTextTospeechOpenAi;
  window.enable_speech_ms = enableTextTospeechMicrosoft;
  window.enable_image_openai = enableTextToImageOpenAi;

  window.aiSelectedVoiceServiceType = aiVoiceServiceType;
  window.aiSelectedVoiceLang = "tr-TR";
  window.aiSelectedVoiceName = aiVoiceName;

  if (enableTextToImageOpenAi) {
    window.ai_image_conf.push({
      name: "OpenAI",
      value: 1,
      sizes: [
        { name: "1024x1024", value: "1024" },
        { name: "1792x1024", value: "1792" },
        { name: "1024x1792", value: "17922" },
      ],
      qualities: [
        { name: "Standard", value: "0" },
        { name: "HD", value: "1" },
      ],
      styles: [
        { name: "Vivid", value: "0" },
        { name: "Natural", value: "1" },
      ],
    });
  }

  if (enableTextTospeechOpenAi) {
    window.ai_speech_conf.push({
      name: "ElevenLabs",
      value: 1,
      lang: [
        {
          name: "tr-TR",
          voices: [
            { name: "Erkek - * Dağhan Aslanger", value: "InTcBOYbBDjVPg15q0rr" },
            { name: "Erkek - * Emre Gökçe", value: "dNjajZuUYmsgcT357Rhg" },
            { name: "Erkek - * Kemal Uğurlu", value: "x5J0w1JGs0MQNyzjoYDc" },
            { name: "Erkek - * Yiğit Atilla", value: "oOSiVtAFJQH0fw31A1we" },
            { name: "Erkek - Asım Mirza Ciftler", value: "mEf7WY0hvNO6KqdAkUeA" },
            { name: "Erkek - Burak Yoğlu", value: "KUfkSkLgALXbMGlHysRz" },
            { name: "Erkek - Süleyman HQ", value: "LToDY4cXEoKGCUVBdZcd" },
            { name: "Erkek - Süleyman Manasırlı", value: "xbkTDhi4jaCwAxBBIavC" },
            { name: "Kadın - *Hicran Vuslat", value: "6CXMImQW1F1c4NFd7zKd" },
            { name: "Kadın - *Hülya", value: "VqMgRfup79a9L4ee93oH" },
            { name: "Kadın - *Hürrem", value: "TASY7VCrU29rEMoYFTGG" },
            { name: "Kadın - *Tomris", value: "bqaNYmxFgK1TN7CL95PZ" },
            { name: "Kadın - Arden", value: "oPe2OnAkyZouGbVh45Ku" },
            { name: "Kadın - Elif", value: "mnEe2Jhwlupp6oZEDi3k" },
            { name: "Kadın - Sevim", value: "H9xk2HncwpOKhhzbyWsd" },
            { name: "Kadın - Sevimcast", value: "LYfSi2g3Frvxg50fRl91" },
          ],
        },
        {
          name: "en-US",
          voices: [
            { name: "Male - Antoni", value: "ErXwobaYiN019PkySvjV" },
            { name: "Male - Bill", value: "pqHfZKP75CvOlQylNhV4" },
            { name: "Male - Charlie", value: "IKne3meq5aSn9XLyUdCD" },
            { name: "Male - George", value: "JBFqnCBsd6RMkjVDRZzb" },
            { name: "Male - Josh", value: "TxGEqnHWrfWFTfGW9XjX" },
            { name: "Female - Dorothy", value: "ThT5KcBeYPX3keUQqHPh" },
            { name: "Female - Grace", value: "oWAxZDx7w5VEj9dCyTzz" },
            { name: "Female - Matilda", value: "XrExE9yKIg1WjnnlVkGX" },
            { name: "Female - Rachel", value: "21m00Tcm4TlvDq8ikWAM" },
            { name: "Female - Sarah", value: "EXAVITQu4vr4xnSDxMaL" },
          ],
        },
      ],
    });
  }

  if (enableTextTospeechMicrosoft) {
    window.ai_speech_conf.push({
      name: "Azure",
      value: 0,
      lang: [
        {
          name: "en-US",
          voices: [
            { name: "Male - Ryan", value: "en-US-RyanMultilingualNeural" },
            { name: "Male - Brandon", value: "en-US-BrandonNeural" },
            { name: "Female - Emma", value: "en-US-EmmaNeural" },
            { name: "Female - Cora", value: "en-US-CoraNeural" },
            { name: "Female - Ava", value: "en-US-AvaNeural" },
          ],
        },
        {
          name: "tr-TR",
          voices: [
            { name: "Male - Ahmet", value: "tr-TR-AhmetNeural" },
            { name: "Female - Emel", value: "tr-TR-EmelNeural" },
          ],
        },
        {
          name: "de-DE",
          voices: [
            { name: "Male - Conrad", value: "de-DE-ConradNeural" },
            { name: "Female - Katja", value: "de-DE-KatjaNeural" },
          ],
        },
        {
          name: "fr-FR",
          voices: [
            { name: "Male - Henri", value: "fr-FR-HenriNeural" },
            { name: "Female - Denise", value: "fr-FR-DeniseNeural" },
          ],
        },
        {
          name: "ar-SA",
          voices: [
            { name: "Male - Hamed", value: "ar-SA-HamedNeural" },
            { name: "Female - Zariyah", value: "ar-SA-ZariyahNeural" },
          ],
        },
        {
          name: "az-AZ",
          voices: [
            { name: "Male - Babek", value: "az-AZ-BabekNeural" },
            { name: "Female - Banu", value: "az-AZ-BanuNeural" },
          ],
        },
        {
          name: "ja-JP",
          voices: [
            { name: "Male - Keita", value: "ja-JP-KeitaNeural" },
            { name: "Female - Nanami", value: "ja-JP-NanamiNeural" },
          ],
        },
      ],
    });
  }

  // Add Gemini TTS support
  window.ai_speech_conf.push({
    name: "Gemini",
    value: 2,
    lang: [
      {
        name: "en-US",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "tr-TR",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "de-DE",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "fr-FR",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "ar-SA",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "az-AZ",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
      {
        name: "ja-JP",
        voices: [
          { name: "Male - Puck", value: "Puck" },
          { name: "Male - Charon", value: "Charon" },
          { name: "Male - Kore", value: "Kore" },
          { name: "Male - Fenrir", value: "Fenrir" },
          { name: "Female - Aoede", value: "Aoede" },
        ],
      },
    ],
  });

  // Add Sestek (Knovvu) TTS support
  // value 4 matches the middleware voiceServiceType (0=Azure,1=ElevenLabs,2=Gemini,3=Google,4=Sestek).
  // Voice lists are fetched live from the middleware per language; the entries
  // below only seed the provider/language dropdowns.
  window.ai_speech_conf.push({
    name: "Sestek",
    value: 4,
    lang: [
      {
        name: "tr-TR",
        voices: [
          { name: "Kadin - Gul", value: "Gul" },
          { name: "Kadin - Gul Premium", value: "GVZ Gul 8k_HV_Premium" },
        ],
      },
      {
        name: "en-US",
        voices: [{ name: "Male - Craig", value: "GVZ Craig 8k" }],
      },
    ],
  });

  if (aiVoiceServiceType !== -1 && aiVoiceName) {
    if (window.ai_speech_conf.filter((a) => a.value == aiVoiceServiceType).length == 0) {
      window.aiSelectedVoiceServiceType = -1;
      window.aiSelectedVoiceName = "";
    }
  }
};

export const getAIConfiguration = () => ({
  speechConf: window.ai_speech_conf || [],
  imageConf: window.ai_image_conf || [],
  selectedVoiceServiceType: window.aiSelectedVoiceServiceType || -1,
  selectedVoiceLang: window.aiSelectedVoiceLang || "tr-TR",
  selectedVoiceName: window.aiSelectedVoiceName || "",
});
